import React from 'react';
import PropTypes from 'prop-types';

import {
  useSearchDispatch,
  useSearchState,
} from '../../../hooks/use_search_state';

export default function ClearFiltersButton(props) {
  const {
    clearBtnClassName,
  } = props;

  const {
    onSaleOnly,
    merchantIds,
    brand,
    category,
    customCategory,
  } = useSearchState();

  const {
    clearFilters,
  } = useSearchDispatch();

  const hasFilters = brand !== '' || category !== '' || customCategory !== '' || merchantIds.length > 0 || onSaleOnly;
  return (
    <div className="snapgadget-clear-filter">
      <button
        disabled={!hasFilters}
        type="button"
        className={clearBtnClassName}
        onClick={() => clearFilters()}
      >
        Clear filters
      </button>
    </div>
  );
}

ClearFiltersButton.propTypes = {
  clearBtnClassName: PropTypes.string.isRequired,
};
